import type { SVGProps } from 'react';
import * as React from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};
const InterfacePencil = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      clipRule="evenodd"
      d="M15.478.5a.65.65 0 0 0-.303.075q-.057.028-.109.06l-.009.005a2 2 0 0 1-.119.065l-.022.01L2.988 12.645a2 2 0 0 0-.14.154.4.4 0 0 0-.087.2c-.156.416-.782 2.086-1.386 3.676-.307.809-.608 1.597-.838 2.188a54 54 0 0 1-.369.92q-.015.037-.024.053l-.012.012-.132.396.592.71.38-.126 6.884-2.64a.4.4 0 0 0 .199-.088c.056-.042.11-.096.154-.14l.004-.004L20.214 6.048c.21-.209.26-.48.214-.767-.046-.28-.188-.587-.382-.895-.387-.618-1.012-1.29-1.63-1.86a17 17 0 0 0-1.213-1.106 7 7 0 0 0-.888-.63c-.288-.166-.583-.29-.837-.29M4.485 12.8 15.5 1.786c.715.455 1.415.992 1.944 1.608l.008.008c.627.627 1.164 1.25 1.616 1.952L8.132 16.383a.6.6 0 0 0-.099-.142 14 14 0 0 0-1.521-1.806 14 14 0 0 0-1.815-1.527l-.01-.007zM2.233 17.81l1.509-4.083c.696.448 1.373.973 1.888 1.573l.008.008c.61.61 1.136 1.217 1.58 1.897l-4.082 1.509z"
      fill="#1C1F2A"
      fillRule="evenodd"
    />
  </svg>
);
export default InterfacePencil;
